/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckSimpleUser } from './deck-simple-user';
import { CompanyJoinRequestsStatusEnum } from './company-join-requests-status-enum';
import { DeckCompanyList } from './deck-company-list';

export interface CompanyJoinRequests {
  readonly id: string;
  readonly user: DeckSimpleUser;
  readonly status: CompanyJoinRequestsStatusEnum;
  readonly company: DeckCompanyList;
  readonly self_publish_ids: Array<number>;
}
export namespace CompanyJoinRequests {}
